import type { HotelCategory } from '../interfaces/hotelCategory'
import { useStars } from './useStars'

interface Categorized {
	provider?: string
	rating?: number | null
	category?: HotelCategory | null
}

export interface DisplayedCategory {
	/** Estrellas a pintar; 0 = ninguna. */
	stars: number
	/** Texto cuando la categoría NO son estrellas: «3 LLAVES», «HOSTAL 2*». */
	text: string | null
	/** Para el tooltip y lectores de pantalla. */
	label: string
}

/**
 * Lo que se le enseña al cliente como categoría del hotel.
 *
 * En Hotelbeds es la categoría OFICIAL del proveedor, sin convertirla (certificación
 * HBX 3.1 y 5.2): las llaves no se vuelven estrellas. Si BookingV2 no la mandó, o el
 * hotel es de Amadeus, sigue el rating del catálogo como hasta ahora.
 */
export const displayedCategory = (hotel: Categorized): DisplayedCategory => {
	const { getStars } = useStars()

	if (hotel.provider === 'hotelbeds' && hotel.category) {
		const stars = getStars(hotel.category.stars)
		const name = hotel.category.name ?? `${stars} estrellas`

		return { stars, text: stars > 0 ? null : name, label: `Categoría: ${name}` }
	}

	const stars = getStars(hotel.rating)

	return {
		stars,
		text: null,
		label: stars > 0 ? `Rating ${stars} de 5` : 'Sin rating registrado',
	}
}
